import { html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { TRANSITION_NAMES } from './bin-issue-reporter-meta';

export const BinIssueStateMixin = (superClass) => class extends superClass {
  constructor() {
    super();
    this.data = {};
    this.collectedFields = this.collectedFields || [];
  }

  static get properties() {
    return {
      noBackButton: { type: Boolean, attribute: 'no-back-button' },
      correctedDimensions: { type: Object, attribute: 'corrected-dimensions' },
      correctedLevels: { type: Object, attribute: 'corrected-levels' },
      comments: { type: String },
      data: { type: Object },
      collectedFields: { type: Array, attribute: false },
      stateHasData: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      p {
        margin: 1em;
      }
      h2 {
        text-align: center;
      }
      .flex {
        display: flex;
        width: 100%;
      }
      .flex.row {
        flex-direction: row;
        align-items: center;
      }
      .flex.col {
        flex-direction: column;
        align-items: center;
      }
      .button-container {
        display: flex;
        justify-content: center;
      }
      .button-container .button {
        margin: 1em;
      }
      .button bn-icon {
        margin-right: .25em;
      }
    `];
  }

  renderYesNo() {
    return html`
      <div class="button-container">
        ${this.renderBack()}
        <button class="button button--contained" @click="${() => this._emitTransition(TRANSITION_NAMES.yes)}">
          <bn-icon name="fas fa-check"></bn-icon> Yes
        </button>
        <button class="button button--outlined" @click="${() => this._emitTransition(TRANSITION_NAMES.no)}">
          <bn-icon name="fas fa-times"></bn-icon> No
        </button>
      </div>
    `;
  }

  renderCancelYes() {
    return html`
      <div class="button-container">
        <button class="button button--outlined" @click="${() => this._emitTransition(TRANSITION_NAMES.cancel)}">
          Cancel
        </button>
        <button class="button button--contained" @click="${() => this._emitTransition(TRANSITION_NAMES.yes)}">
          <bn-icon name="fas fa-check"></bn-icon> Yes
        </button>
      </div>
    `;
  }

  renderNext() {
    return html`
      <div class="button-container">
        ${this.renderBack()}
        <button
          class="button button--contained"
          @click="${() => this._emitTransition(TRANSITION_NAMES.next)}"
          ?disabled="${!this.stateHasData}"
        >
          Next
        </button>
      </div>
    `;
  }

  renderSubmit() {
    return html`
      <div class="button-container">
        ${this.renderBack()}
        <button
          class="button button--contained"
          @click="${() => this._emitTransition(TRANSITION_NAMES.submit)}"
          ?disabled="${!this.stateHasData}"
        >
          Submit
        </button>
      </div>
    `;
  }

  renderBack() {
    if (this.noBackButton) {
      return html``;
    }

    return html`
      <button class="button button--text" @click="${() => this._emitTransition(TRANSITION_NAMES.back)}">
        <bn-icon name="fas fa-arrow-left"></bn-icon> Back
      </button>
    `;
  }

  _emitTransition(transitionName) {
    const dataToEmit = {};
    this.collectedFields.forEach((field) => {
      dataToEmit[field] = this.data[field];
    });

    this.dispatchEvent(new CustomEvent('transition', {
      detail: { transitionName, collectedData: dataToEmit },
      composed: true,
      bubbles: false,
    }));

    if (transitionName === TRANSITION_NAMES.back) {
      this.dispatchEvent(new CustomEvent('clear-fields', {
        detail: { fields: this.collectedFields },
        composed: true,
        bubbles: false,
      }));
    }
  }
};
